import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { ProgressBarContainer, CurrentProgress } from './styles.js';
import { Flex } from '../Flex/Flex.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

function ProgressBar(_a) {
    var { label, currentStep, totalSteps, variation = 'primary' } = _a, props = __rest(_a, ["label", "currentStep", "totalSteps", "variation"]);
    const currentProgress = Math.round((currentStep / totalSteps) * 100);
    return (React.createElement(Flex, Object.assign({ flexDirection: "column", width: "100%", role: "progressbar", "aria-valuemin": 1, "aria-valuenow": currentStep, "aria-valuemax": totalSteps }, props),
        label && (React.createElement(ParagraphMd, { type: "default", bold: true, mb: "stack.1xsmall" }, label)),
        React.createElement(ProgressBarContainer, null,
            React.createElement(CurrentProgress, { progress: currentProgress, variation: variation, "data-testid": "progressbar-current-progress" }))));
}

export { ProgressBar };
